class RoomsClass {
  constructor() {

    this.subtitle = {
      en: "We have many different types of rooms which are detailed below.",
      kr: "우리 호텔에는 아래에 설명한 바와 같이 다양한 형태의 방이 있습니다.",
      jp: "以下に、さまざまなタイプの客室をご紹介しています。",
      cn: "我们有许多不同类型的客房，详细信息如下。",
    }

    this.guide = {
      en: "Please, click the room name below, for detailed info.",
      kr: "자세한 정보를 보려면 아래의 객실 이름을 클릭하세요.",
      jp: "以下の部屋名をクリックして、詳細情報を表示してください。",
      cn: "请点击下方的房间名称，获取详细信息。",
    }

    this.rooms = {
      en: {
        summary: "",
        rooms: [
          {
            id: "a2room",
            room_name: "Apartment for 2",
            des: ["The apartment is for 2 persons. It is about 16 square meters wide and equipped with two single beds, private shower, toilet, a refrigerator, a microwave oven, 32 inch LED TV, a hair dryer, a water kettle, and a vacuum cleaner. Price ranges from 5,600 to 12,000 yen."
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a2/a2_room1.jpg" },
              { what: "room", photo: "photos/rooms/a2/a2_room2.jpg" },
              { what: "closet", photo: "photos/rooms/a2/a2_closet.jpg" },
              { what: "bathroom", photo: "photos/rooms/a2/a2_bathroom.jpg" }
            ]
          },
          {
            id: "a3room",
            room_name: "Apartment for 3",
            des: ["The apartment is for 3 persons. It is about 16 square meters wide and equipped with 2 single beds, 1 underbed, a private shower, a toilet, a refrigerator, a microwave oven, 32 inch LED TV, a hair dryer, a water kettle, and a vacuum cleaner.  Price ranges from 7,500 to 15,000 yen."
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a2/a2_room1.jpg" },
              { what: "room", photo: "photos/rooms/a2/a2_room2.jpg" },
              { what: "closet", photo: "photos/rooms/a2/a2_closet.jpg" },
              { what: "bathroom", photo: "photos/rooms/a2/a2_bathroom.jpg" }
            ]
          },
          {
            id: "a4room",
            room_name: "Apartment for 4",
            des: ["The apartment is for 4 persons. It is about 18 square meters wide and equipped with 2 single beds, 2 underbeds, a private shower, a toilet, a refrigerator, a microwave oven, 32 inch LED TV, a hair dryer, a water kettle, dehumidifier, and a vacuum cleaner. Price ranges from 9,800 to 18,000 yen."
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a4/a4_room1.jpg" },
              { what: "room", photo: "photos/rooms/a4/a4_room2.jpg" },
              { what: "room", photo: "photos/rooms/a4/a4_room3.jpg" },
              { what: "shower", photo: "photos/rooms/a4/a4_shower1.jpg" },
              { what: "shower", photo: "photos/rooms/a4/a4_shower2.jpg" },
              { what: "toilet", photo: "photos/rooms/a4/a4_toilet.jpg" }
            ]
          },
          {
            id: "a5room",
            room_name: "Apartment for 5",
            des: ["The apartment is for 5 persons. It is about 20 square meters wide and equipped with two double beds, 1 sofa bed, private shower, toilet, a refrigerator, a microwave oven, 32 inch LED TV, a hair dryer, a water kettle, and a vacuum cleaner. Price ranges from 11,000 to 20,000 yen."
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a5/a5_room2.jpg" },
              { what: "room", photo: "photos/rooms/a5/a5_room3.jpg" },
              { what: "shower", photo: "photos/rooms/a5/a5_shower.jpg" },
              { what: "toilet", photo: "photos/rooms/a5/a5_toilet.jpg" }
            ]
          },
          {
            id: "a6room",
            room_name: "Apartment for 6",
            des: ["The apartment is for 6 persons. It is about 30 square meters and equipped with two double beds, two underbeds, a private shower, a toilet, a refrigerator, a microwave oven, 32 inch LED TV, a hair dryer, a water kettle, and a vacuum cleaner. Price ranges from 13,000 to 24,000 yen."
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a6/a6_bedroom1.jpg" },
              { what: "room", photo: "photos/rooms/a6/a6_bedroom2.jpg" },
              { what: "room", photo: "photos/rooms/a6/a6_bedroom3.jpg" },
              { what: "kitchen", photo: "photos/rooms/a6/a6_kitchen.jpg" },
              { what: "shower", photo: "photos/rooms/a6/a6_shower.jpg" },
              { what: "toilet", photo: "photos/rooms/a6/a6_toilet.jpg" },
            ]
          },
          {
            id: "p2room",
            room_name: "bunk bed for 2",
            des: ["The room is for 2 persons. It is about 12 square meters wide and equipped with a bunk bed, private shower, toilet, a hair dryer, and a water kettle.  Price ranges from 3,000 to 7,000 yen."
            ],
            photos: [
              { what: "room", photo: "photos/rooms/p2/p2_room1.jpg" },
              { what: "shower", photo: "photos/rooms/p2/p2_shower_new.jpg" },
              { what: "toilet", photo: "photos/rooms/p2/p2_toilet.jpg" }
            ]
          },
          {
            id: "p2droom",
            room_name: "room with a double bed",
            des: ["The room is for 2 persons. It is about 14 square meters wide and equipped with 1 double bed, private shower, toilet, a hair dryer, and a water kettle.  Price ranges from 3,000 to 7,000 yen."],
            photos: [
              { what: "room", photo: "photos/rooms/p2d/p2d_room.jpg" },
              { what: "room", photo: "photos/rooms/p2d/p2d_view_from_out.jpg" },
              { what: "shower", photo: "photos/rooms/p2d/p2d_shower.jpg" },
              { what: "toilet", photo: "photos/rooms/p2d/p2d_toilet.jpg" }
            ]
          },
        ]
      },
      kr: {
        summary: "",
        rooms: [
          {
            id: "a2room",
            room_name: "2인용 아파트",
            des: ["이 아파트는 2인용입니다. 약 16 평방 미터 정도의 공간에는 싱글 침대 두 개, 개인 샤워실, 화장실, 냉장고, 전자렌지, 32인치 LED TV, 헤어 드라이어, 전기 주전자 및 진공 청소기가 구비되어 있습니다. 가격은 5,600엔에서 12,000엔까지 다양합니다."
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a2/a2_room1.jpg" },
              { what: "room", photo: "photos/rooms/a2/a2_room2.jpg" },
              { what: "closet", photo: "photos/rooms/a2/a2_closet.jpg" },
              { what: "bathroom", photo: "photos/rooms/a2/a2_bathroom.jpg" }
            ]
          },
          {
            id: "a3room",
            room_name: "3인용 아파트",
            des: ["3인용 아파트입니다. 면적은 약 16제곱미터이며 2개의 싱글 침대, 1개의 이불 침대, 개인 샤워실, 화장실, 냉장고, 전자레인지, 32인치 LED TV, 헤어드라이어, 전기주전자 및 청소기가 구비되어 있습니다. 가격은 7,500엔에서 15,000엔까지 변동됩니다."
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a2/a2_room1.jpg" },
              { what: "room", photo: "photos/rooms/a2/a2_room2.jpg" },
              { what: "closet", photo: "photos/rooms/a2/a2_closet.jpg" },
              { what: "bathroom", photo: "photos/rooms/a2/a2_bathroom.jpg" }
            ]
          },
          {
            id: "a4room",
            room_name: "4인용 아파트",
            des: ["이 아파트는 4명을 수용할 수 있습니다. 면적은 약 18㎡이며, 2개의 싱글 침대, 2개의 이불 침대, 개인 샤워실, 화장실, 냉장고, 전자 레인지, 32인치 LED TV, 헤어 드라이어, 전기 주전자, 제습기 및 진공 청소기가 설치되어 있습니다. 가격은 9,800 ~ 18,000엔입니다."
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a4/a4_room1.jpg" },
              { what: "room", photo: "photos/rooms/a4/a4_room2.jpg" },
              { what: "room", photo: "photos/rooms/a4/a4_room3.jpg" },
              { what: "shower", photo: "photos/rooms/a4/a4_shower1.jpg" },
              { what: "shower", photo: "photos/rooms/a4/a4_shower2.jpg" },
              { what: "toilet", photo: "photos/rooms/a4/a4_toilet.jpg" }
            ]
          },
          {
            id: "a5room",
            room_name: "5인용 아파트",
            des: ["이 아파트는 5 인용입니다. 폭은 약 20 제곱미터이며 더블 침대 2 개, 소파 베드 1 개, 개인 샤워, 화장실, 냉장고, 전자 레인지, 32 인치 LED TV, 헤어 드라이어, 전기 주전자 및 진공 청소기가 갖추어져 있습니다. 가격은 11,000 ~ 20,000 엔입니다."
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a5/a5_room2.jpg" },
              { what: "room", photo: "photos/rooms/a5/a5_room3.jpg" },
              { what: "shower", photo: "photos/rooms/a5/a5_shower.jpg" },
              { what: "toilet", photo: "photos/rooms/a5/a5_toilet.jpg" }
            ]
          },
          {
            id: "a6room",
            room_name: "6인용 아파트",
            des: ["이 아파트는 6명이 머무를 수 있습니다. 면적은 약 30제곱미터이며 더블 침대 두 개, 추가 침대 두 개, 개인 샤워실, 화장실, 냉장고, 전자 레인지, 32인치 LED TV, 헤어 드라이어, 전기 주전자 및 청소기가 갖추어져 있습니다. 가격은 13,000에서 24,000엔까지 다양합니다."
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a6/a6_bedroom1.jpg" },
              { what: "room", photo: "photos/rooms/a6/a6_bedroom2.jpg" },
              { what: "room", photo: "photos/rooms/a6/a6_bedroom3.jpg" },
              { what: "kitchen", photo: "photos/rooms/a6/a6_kitchen.jpg" },
              { what: "shower", photo: "photos/rooms/a6/a6_shower.jpg" },
              { what: "toilet", photo: "photos/rooms/a6/a6_toilet.jpg" },
            ]
          },
          {
            id: "p2room",
            room_name: "2인실(이층침대)",
            des: ["그 방은 2 인용입니다. 약 12 제곱미터 폭으로 이층침대, 전용 샤워실, 화장실, 헤어 드라이어 및 전기 주전자가 설치되어 있습니다. 가격은 3,000 ~ 7,000 엔입니다."
            ],
            photos: [
              { what: "room", photo: "photos/rooms/p2/p2_room1.jpg" },
              { what: "shower", photo: "photos/rooms/p2/p2_shower_new.jpg" },
              { what: "toilet", photo: "photos/rooms/p2/p2_toilet.jpg" }
            ]
          },
          {
            id: "p2droom",
            room_name: "더블베드룸",
            des: ["이 객실은 2인용입니다. 약 14 제곱미터의 넓이에 더블 침대 1개, 전용 샤워실, 화장실, 헤어 드라이어, 전기 주전자가 구비되어 있습니다. 가격은 3,000에서 7,000 엔입니다."],
            photos: [
              { what: "room", photo: "photos/rooms/p2d/p2d_room.jpg" },
              { what: "room", photo: "photos/rooms/p2d/p2d_view_from_out.jpg" },
              { what: "shower", photo: "photos/rooms/p2d/p2d_shower.jpg" },
              { what: "toilet", photo: "photos/rooms/p2d/p2d_toilet.jpg" }
            ]
          },
        ]
      },
      jp: {
        summary: "",
        rooms: [
          {
            id: "a2room",
            room_name: "2人用のアパートメント",
            des: ["そのアパートメントは2人用です。約16平方メートルで、シングルベッド2台、専用のシャワー、トイレ、冷蔵庫、電子レンジ、32インチのLEDテレビ、ヘアドライヤー、湯沸かしポット、掃除機が備わっています。価格は5,600円から12,000円です。"],
            photos: [
              { what: "room", photo: "photos/rooms/a2/a2_room1.jpg" },
              { what: "room", photo: "photos/rooms/a2/a2_room2.jpg" },
              { what: "closet", photo: "photos/rooms/a2/a2_closet.jpg" },
              { what: "bathroom", photo: "photos/rooms/a2/a2_bathroom.jpg" }
            ]
          },
          {
            id: "a3room",
            room_name: "3人用のアパートメント",
            des: ["3人用のアパートメントです。約16平方メートルの広さで、シングルベッド2台、下に敷くためのベッド1台、専用シャワー、トイレ、冷蔵庫、電子レンジ、32インチのLEDテレビ、ヘアドライヤー、湯沸かしポット、掃除機が備わっています。価格は7,500円から15,000円までの範囲です。"
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a2/a2_room1.jpg" },
              { what: "room", photo: "photos/rooms/a2/a2_room2.jpg" },
              { what: "closet", photo: "photos/rooms/a2/a2_closet.jpg" },
              { what: "bathroom", photo: "photos/rooms/a2/a2_bathroom.jpg" }
            ]
          },
          {
            id: "a4room",
            room_name: "4人用のアパートメント",
            des: ["そのアパートメントは4人用です。約18平方メートルで、シングルベッド2台、アンダーベッド2台、専用シャワー、トイレ、冷蔵庫、電子レンジ、32インチLEDテレビ、ヘアドライヤー、電気ポット、除湿機、掃除機が備わっています。価格は9,800から18,000円です。"
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a4/a4_room1.jpg" },
              { what: "room", photo: "photos/rooms/a4/a4_room2.jpg" },
              { what: "room", photo: "photos/rooms/a4/a4_room3.jpg" },
              { what: "shower", photo: "photos/rooms/a4/a4_shower1.jpg" },
              { what: "shower", photo: "photos/rooms/a4/a4_shower2.jpg" },
              { what: "toilet", photo: "photos/rooms/a4/a4_toilet.jpg" }
            ]
          },
          {
            id: "a5room",
            room_name: "5人用のアパートメント",
            des: ["このアパートメントは5人用です。面積は約20平方メートルで、ダブルベッド2台、ソファーベッド1台、専用シャワー、トイレ、冷蔵庫、電子レンジ、32インチのLEDテレビ、ヘアドライヤー、電気ポット、掃除機が備わっています。価格は11,000〜20,000円です。"
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a5/a5_room2.jpg" },
              { what: "room", photo: "photos/rooms/a5/a5_room3.jpg" },
              { what: "shower", photo: "photos/rooms/a5/a5_shower.jpg" },
              { what: "toilet", photo: "photos/rooms/a5/a5_toilet.jpg" }
            ]
          },
          {
            id: "a6room",
            room_name: "6人用のアパートメント",
            des: ["このアパートメントは6人用です。約30平方メートルで、ダブルベッド2台、アンダーベッド2台、専用シャワー、トイレ、冷蔵庫、電子レンジ、32インチのLEDテレビ、ヘアドライヤー、湯沸かしポット、掃除機が備わっています。価格は13,000から24,000円です。"
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a6/a6_bedroom1.jpg" },
              { what: "room", photo: "photos/rooms/a6/a6_bedroom2.jpg" },
              { what: "room", photo: "photos/rooms/a6/a6_bedroom3.jpg" },
              { what: "kitchen", photo: "photos/rooms/a6/a6_kitchen.jpg" },
              { what: "shower", photo: "photos/rooms/a6/a6_shower.jpg" },
              { what: "toilet", photo: "photos/rooms/a6/a6_toilet.jpg" },
            ]
          },
          {
            id: "p2room",
            room_name: "2人用二段ベッド",
            des: ["この部屋は2人用です。約12平方メートルの広さで、二段ベッド、専用シャワー、トイレ、ヘアドライヤー、湯沸かしポットが備わっています。価格は3,000から7,000円です。"
            ],
            photos: [
              { what: "room", photo: "photos/rooms/p2/p2_room1.jpg" },
              { what: "shower", photo: "photos/rooms/p2/p2_shower_new.jpg" },
              { what: "toilet", photo: "photos/rooms/p2/p2_toilet.jpg" }
            ]
          },
          {
            id: "p2droom",
            room_name: "2人用のダブルベッド",
            des: ["この部屋は2人用です。約14平方メートルの広さで、ダブルベッド1台、専用のシャワー、トイレ、ヘアドライヤー、湯沸かしポットが備わっています。価格は3,000から7,000円です。"],
            photos: [
              { what: "room", photo: "photos/rooms/p2d/p2d_room.jpg" },
              { what: "room", photo: "photos/rooms/p2d/p2d_view_from_out.jpg" },
              { what: "shower", photo: "photos/rooms/p2d/p2d_shower.jpg" },
              { what: "toilet", photo: "photos/rooms/p2d/p2d_toilet.jpg" }
            ]
          },
        ]
      },
      cn: {
        summary: "",
        rooms: [
          {
            id: "a2room",
            room_name: "两人公寓",
            des: ["公寓面积约16平方米，配有两张单人床、私人淋浴、厕所、冰箱、微波炉、32英寸LED电视、吹风机、热水壶和吸尘器，适合2人入住。价格从5,600日元到12,000日元不等。"
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a2/a2_room1.jpg" },
              { what: "room", photo: "photos/rooms/a2/a2_room2.jpg" },
              { what: "closet", photo: "photos/rooms/a2/a2_closet.jpg" },
              { what: "bathroom", photo: "photos/rooms/a2/a2_bathroom.jpg" }
            ]
          },
          {
            id: "a3room",
            room_name: "三人公寓",
            des: ["这间公寓可供3人入住。面积约16平方米，配有2张单人床、1张下铺床、私人淋浴、厕所、冰箱、微波炉、32英寸LED电视、吹风机、热水壶和吸尘器。价格范围为7,500日元至15,000日元。"
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a2/a2_room1.jpg" },
              { what: "room", photo: "photos/rooms/a2/a2_room2.jpg" },
              { what: "closet", photo: "photos/rooms/a2/a2_closet.jpg" },
              { what: "bathroom", photo: "photos/rooms/a2/a2_bathroom.jpg" }
            ]
          },
          {
            id: "a4room",
            room_name: "四人公寓",
            des: ["这间公寓适合4人入住。宽约18平方米，配有2张单人床、2张底床、私人淋浴、厕所、冰箱、微波炉、32英寸LED电视、吹风机、热水壶、除湿机和吸尘器。价格范围为9,800日元至18,000日元。"
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a4/a4_room1.jpg" },
              { what: "room", photo: "photos/rooms/a4/a4_room2.jpg" },
              { what: "room", photo: "photos/rooms/a4/a4_room3.jpg" },
              { what: "shower", photo: "photos/rooms/a4/a4_shower1.jpg" },
              { what: "shower", photo: "photos/rooms/a4/a4_shower2.jpg" },
              { what: "toilet", photo: "photos/rooms/a4/a4_toilet.jpg" }
            ]
          },
          {
            id: "a5room",
            room_name: "五人公寓",
            des: ["这套公寓可供5人入住。面积约20平方米，配有两张双人床，1张沙发床，私人淋浴间，卫生间，冰箱，微波炉，32英寸LED电视，吹风机，热水壶和吸尘器。价格范围为11,000到20,000日元。"
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a5/a5_room2.jpg" },
              { what: "room", photo: "photos/rooms/a5/a5_room3.jpg" },
              { what: "shower", photo: "photos/rooms/a5/a5_shower.jpg" },
              { what: "toilet", photo: "photos/rooms/a5/a5_toilet.jpg" }
            ]
          },
          {
            id: "a6room",
            room_name: "六人公寓",
            des: ["这间公寓可容纳6人。约30平方米，配有两张双人床、两张底床、私人淋浴间、厕所、冰箱、微波炉、32英寸LED电视、吹风机、电水壶和吸尘器。价格为13,000至24,000日元。"
            ],
            photos: [
              { what: "room", photo: "photos/rooms/a6/a6_bedroom1.jpg" },
              { what: "room", photo: "photos/rooms/a6/a6_bedroom2.jpg" },
              { what: "room", photo: "photos/rooms/a6/a6_bedroom3.jpg" },
              { what: "kitchen", photo: "photos/rooms/a6/a6_kitchen.jpg" },
              { what: "shower", photo: "photos/rooms/a6/a6_shower.jpg" },
              { what: "toilet", photo: "photos/rooms/a6/a6_toilet.jpg" },
            ]
          },
          {
            id: "p2room",
            room_name: "双层床（适合2人）",
            des: ["这间房间适合2人。宽约12平方米，配有一张双层床、私人淋浴间、厕所、吹风机和水壶。价格范围为3,000到7,000日元。"
            ],
            photos: [
              { what: "room", photo: "photos/rooms/p2/p2_room1.jpg" },
              { what: "shower", photo: "photos/rooms/p2/p2_shower_new.jpg" },
              { what: "toilet", photo: "photos/rooms/p2/p2_toilet.jpg" }
            ]
          },
          {
            id: "p2droom",
            room_name: "双人床",
            des: ["这间房间适合2人入住。面积约为14平方米，配有1张双人床，私人淋浴间、厕所、吹风机和热水壶。价格范围为3,000到7,000日元。"],
            photos: [
              { what: "room", photo: "photos/rooms/p2d/p2d_room.jpg" },
              { what: "room", photo: "photos/rooms/p2d/p2d_view_from_out.jpg" },
              { what: "shower", photo: "photos/rooms/p2d/p2d_shower.jpg" },
              { what: "toilet", photo: "photos/rooms/p2d/p2d_toilet.jpg" }
            ]
          },
        ]
      },
    }
  }

  get_rooms_info(lang) {
    switch (lang) {
      case 'en': return this.rooms.en
      case 'kr': return this.rooms.kr
      case 'jp': return this.rooms.jp
      case 'cn': return this.rooms.cn
    }
  }

  get_subtitle(lang) {
    switch (lang) {
      case 'en': return this.subtitle.en
      case 'kr': return this.subtitle.kr
      case 'jp': return this.subtitle.jp
      case 'cn': return this.subtitle.cn
    }
  }

  get_guide(lang) {
    switch (lang) {
      case 'en': return this.guide.en
      case 'kr': return this.guide.kr
      case 'jp': return this.guide.jp
      case 'cn': return this.guide.cn
    }
  }


}
export let rooms_utils = new RoomsClass();